import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountdownModule } from 'ngx-countdown';

import { ComponentsModule } from '../core/components/components.module';
import { CadastroAgendamentoComponent } from './agendamento/cadastro-agendamento/cadastro-agendamento.component';
import { CadastroPagamentoAgendamentoComponent } from './agendamento/cadastro-pagamento-agendamento/cadastro-pagamento-agendamento.component';
import { ListagemAgendamentoComponent } from './agendamento/listagem-agendamento/listagem-agendamento.component';
import { TicketAgendamentoComponent } from './agendamento/ticket-agendamento/ticket-agendamento.component';
import { CadastroCarretaComponent } from './cadastro-frota/carreta/cadastro-carreta/cadastro-carreta.component';
import { ListagemCarretaComponent } from './cadastro-frota/carreta/listagem-carreta/listagem-carreta.component';
import { CadastroCavaloComponent } from './cadastro-frota/cavalo/cadastro-cavalo/cadastro-cavalo.component';
import { ListagemCavaloComponent } from './cadastro-frota/cavalo/listagem-cavalo/listagem-cavalo.component';
import { HomeComponent } from './home/home.component';
import { LoginUsuarioComponent } from './login-usuario/login-usuario.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { EmailSenhaComponent } from './recuperar-senha/email-senha/email-senha.component';
import { EsqueciSenhaComponent } from './recuperar-senha/esqueci-senha/esqueci-senha.component';
import { ListagemServicosComponent } from './servicos/listagem-servicos/listagem-servicos.component';
import { ListagemLaudosHigienizacaoComponent } from './laudo-higienizacao/listagem-laudos-higienizacao/listagem-laudos-higienizacao.component';
import { CadastroLaudoHigienizacaoComponent } from './laudo-higienizacao/cadastro-laudo-higienizacao/cadastro-laudo-higienizacao.component';
import { CadastroEntradaServicosComponent } from './servicos/cadastro-entrada-servicos/cadastro-entrada-servicos.component';
import { CadastroUsuarioComponent } from './usuario/cadastro-usuario/cadastro-usuario.component';

@NgModule({
  declarations: [
    CadastroLaudoHigienizacaoComponent,
    CadastroEntradaServicosComponent,
    CadastroAgendamentoComponent,
    CadastroPagamentoAgendamentoComponent,
    ListagemAgendamentoComponent,
    TicketAgendamentoComponent,
    CadastroCarretaComponent,
    ListagemCarretaComponent,
    CadastroCavaloComponent,
    ListagemCavaloComponent,
    HomeComponent,
    LoginUsuarioComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    ListagemServicosComponent,
    ListagemLaudosHigienizacaoComponent,
    CadastroUsuarioComponent,
    NotFoundComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    ComponentsModule
  ],
  exports: [
    CadastroLaudoHigienizacaoComponent,
    CadastroEntradaServicosComponent,
    CadastroAgendamentoComponent,
    CadastroPagamentoAgendamentoComponent,
    ListagemAgendamentoComponent,
    TicketAgendamentoComponent,
    CadastroCarretaComponent,
    ListagemCarretaComponent,
    CadastroCavaloComponent,
    ListagemCavaloComponent,
    HomeComponent,
    LoginUsuarioComponent,
    EmailSenhaComponent,
    EsqueciSenhaComponent,
    ListagemServicosComponent,
    ListagemLaudosHigienizacaoComponent,
    CadastroUsuarioComponent,
    NotFoundComponent
  ]
})
export class PagesModule {}
